import React from "react";
import {Banner} from "../index";
import {ChildrenProps} from "../../../utils";
import {BannerType} from "../Banner/Banner";

type Props = ChildrenProps;

const BannerQuestion = ({children}: Props) => {
  return (
    <>
      <Banner type={BannerType.QUESTION}>
        {children}
      </Banner>
    </>
  );
};

export default BannerQuestion;